/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Plausible_DescriptionInputs */

const en_admin_settings_groups_plausible_description = /** @type {(inputs: Admin_Settings_Groups_Plausible_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports both site-specific and legacy scripts for self-hosted or cloud Plausible`)
};

/**
* | output |
* | --- |
* | "Supports both site-specific and legacy scripts for self-hosted or cloud Plausible" |
*
* @param {Admin_Settings_Groups_Plausible_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_plausible_description = /** @type {((inputs?: Admin_Settings_Groups_Plausible_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Plausible_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_plausible_description(inputs)
});
export { admin_settings_groups_plausible_description as "admin.settings.groups.plausible.description" }